import {Typography} from "@mui/material"
import React from "react"

function TextToHTML({text, ...props}: {text: string} & React.ComponentProps<typeof Typography>) {
	const dangerousText = {__html: text.replace(/(?:\r\n|\r|\n)/g, "<br />")}
	return <Typography {...props} dangerouslySetInnerHTML={dangerousText} />
}

export {TextToHTML}
